import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/user.service';

@Component({
  selector: 'app-legacy-redirect',
  templateUrl: './legacy-redirect.component.html',
  styleUrls: ['./legacy-redirect.component.scss'],
})
export class LegacyRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private userService: UserService,
  ) {}

  public ngOnInit(): void {
    const url = this.router.url;

    // 1. Example: /file/123/history -> /file-history/123
    const match = url.match(/^\/file\/([^\/]+)\/history$/);
    if (match) {
      const id = match[1];
      this.router.navigateByUrl(`/file-history/${id}`);
      return;
    }

    // 2. Redirect: /getstarted → user's dashboard preference
    if (url === '/account/getstarted') {
      const dashboard = this.userService.get('dashboard') || 'files';
      this.router.navigate([`/${dashboard}`], { queryParams: undefined });
      return;
    }

    // Redirect all upgrade/getspace paths to /settings/billing to trigger the Chargebee billing portal
    const billingRoutes = ['/account/getspace', '/getspace', '/upgrade', '/account/upgrade'];

    if (billingRoutes.includes(url)) {
      this.router.navigate(['/settings/billing'], {
        queryParams: { showBilling: 'true' },
      });
      return;
    }

    // Fallback
    this.router.navigateByUrl('/not-found');
  }
}
